import * as React from "react";
import { connect } from "react-redux";

import { IOption } from "../../classes/option";
import { IState } from "../../classes/state";

import { EventDetailsView } from "./EventDetailsView";

import * as ajaxActions from "../../actions/ajaxActions";
import * as calendarSettingsActions from "../../actions/calendarSettingsActions";
import * as eventViewActions from "../../actions/eventViewActions";

import * as dates from "../../reducers/changeTimePeriod";

export class EventDetailsViewContainer extends React.Component<any, any> {

  public constructor(props: any, context: any) {
    super(props, context);
  }

  public render() {

    const isLoading = this.props.numAjaxCallsInProgress > 0;

    return (
      <div>
        <EventDetailsView
          calendarId={this.props.calendarId}
          contextId={this.props.contextId}
          currentEvent={this.props.currentEvent}
          iCalStartDate={this.props.iCalStartDate}
          eventId={this.props.eventId}
          isLoading={isLoading}
          localEndDate={this.props.displayedEventLocalEndDate}
          localStartDate={this.props.displayedEventLocalStartDate}
          pageId={this.props.pageId}
          portletInstanceId={this.props.portletInstanceId}
          selectedDate={this.props.selectedDate}
          text={this.props.text}
          useModernAddAndEditEventScreen={this.props.useModernAddAndEditEventScreen}
          userDateFormat={this.props.userDateFormat}
          viewMode={this.props.viewMode}
          requestEventDetailFromService={this.props.requestEventDetailFromService}
          onSetEventIdToZero={this.props.setEventIdToZero}
          onSetEventScreenMode={this.props.setEventScreenMode}
          onStartAjaxCall={this.props.startAjaxCall}
          registerForEventFromService={this.props.registerForEventFromService}
          unregisterFromEventFromService={this.props.unregisterFromEventFromService}
          deleteEventFromService={this.props.deleteEventFromService}
          exportFileFromService={this.props.exportFileFromService}
        />
      </div>
    );
  }

}

const mapStateToProps = (state: IState, ownProps: any) => { // 'state' is the state in our Redux Store; 'ownProps' is a reference to this component's own this.props.
  return {
    calendarId: state.calendarSettings.calendarId,
    contextId: state.calendarSettings.contextId,
    currentEvent: state.currentEvent,
    displayedEventLocalEndDate: state.calendarSettings.displayedEventLocalEndDate,
    displayedEventLocalStartDate: state.calendarSettings.displayedEventLocalStartDate,
    eventId: state.calendarSettings.displayedEventId,
    iCalStartDate: state.calendarSettings.iCalStartDate,
    numAjaxCallsInProgress: state.numAjaxCallsInProgress,
    pageId: state.calendarSettings.pageId,
    portletInstanceId: state.calendarSettings.portletInstanceId,
    selectedDate: state.calendarSettings.selectedDate,
    text: state.text,
    useModernAddAndEditEventScreen: state.calendarSettings.useModernAddAndEditEventScreen,
    userDateFormat: state.calendarSettings.userDateFormat,
    viewMode: state.calendarSettings.viewMode,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    deleteEventFromService: (portletInstanceId: number, objectId: number, parentId: number, contextId: number, deleteThisEventInstanceOnly: boolean, eventInstanceDate: Date) => {
      const action = eventViewActions.deleteEventFromService(portletInstanceId, objectId, parentId, contextId, deleteThisEventInstanceOnly, eventInstanceDate);
      dispatch(action);
    },
    exportFileFromService: (calendarId: number, eventId: number, isAllDay: boolean, title: string, location: string, description: string, category: string, localStartDate: Date, localEndDate: Date) => {
      const action = eventViewActions.exportFileFromService(calendarId, eventId, isAllDay, title, location, description, category, localStartDate, localEndDate);
      dispatch(action);
    },
    registerForEventFromService: (eventId: number, calendarId: number) => {
      const action = eventViewActions.registerForEventFromService(eventId, calendarId);
      dispatch(action);
    },
    requestEventDetailFromService: (portletInstanceId: number, calendarId: number, eventId: number, localStartDate: Date, localEndDate: Date) => {
      const action = eventViewActions.requestEventDetailFromService(portletInstanceId, calendarId, eventId, localStartDate, localEndDate);
      dispatch(action);
    },
    setEventIdToZero: () => {
      const action = calendarSettingsActions.setEventId(0);
      dispatch(action);
    },
    setEventScreenMode: (eventScreenMode: string) => {
      const action = calendarSettingsActions.setEventScreenMode(eventScreenMode);
      dispatch(action);
    },
    startAjaxCall: () => {
      const action = ajaxActions.beginAjaxCall();
      dispatch(action);
    },
    unregisterFromEventFromService: (eventId: number, calendarId: number, localStartDate: Date, localEndDate: Date) => {
      const action = eventViewActions.unregisterFromEventFromService(eventId, calendarId, localStartDate, localEndDate);
      dispatch(action);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDetailsViewContainer);
